"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeAreaTick = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var colors_1 = require("../../styles/colors");
var string_1 = require("../../util/string");
var Tooltip_1 = require("../Tooltip");
var Icon_1 = require("../Icon");
function RangeAreaTick(props) {
    var _a, _b, _c;
    var _d = props.viewBox, x = _d.x, y = _d.y, width = _d.width, referenceArea = props.referenceArea;
    var nameLines = string_1.splitIntoLines(referenceArea.name, Math.floor(width / 10));
    var fill = ((_b = (_a = referenceArea.tickColor) !== null && _a !== void 0 ? _a : referenceArea.fillColor) !== null && _b !== void 0 ? _b : colors_1.blue.c60) || 'none';
    var centerX = x + width / 2;
    var hasTooltip = Boolean(referenceArea.tooltip);
    var iconOffsetX = hasTooltip ? 10 : 0;
    var lineHeight = 17;
    var totalTextHeight = Math.max(1, nameLines.length) * lineHeight;
    var halfText = totalTextHeight / 2;
    var barTop = y - 7;
    var gap = 4;
    var labelCenterY = barTop - gap - halfText;
    var labelTranslateX = centerX - iconOffsetX;
    var labelTranslateY = labelCenterY;
    var firstDy = -((nameLines.length - 1) / 2) * lineHeight;
    var ICON_PX = 16;
    var tooltipX = (((_c = nameLines[0]) === null || _c === void 0 ? void 0 : _c.length) || 0) * 4;
    var tooltipCenterOffset = -1;
    var tooltipY = -ICON_PX / 2 + tooltipCenterOffset;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { transform: "translate(" + labelTranslateX + ", " + labelTranslateY + ")" },
            react_1.default.createElement("text", { textAnchor: 'middle', dominantBaseline: 'middle', fill: fill, style: { fontWeight: 'bold' } }, nameLines.map(function (namePart, i) {
                return namePart ? (react_1.default.createElement("tspan", { key: i + "-" + namePart, x: 0, dy: i === 0 ? firstDy : lineHeight, textAnchor: 'middle' }, namePart)) : null;
            })),
            referenceArea.tooltip && (react_1.default.createElement(Tooltip_1.Tooltip, { text: referenceArea.tooltip },
                react_1.default.createElement(Icon_1.Icon, { x: tooltipX, y: tooltipY, icon: 'infoCircleFilled', size: 1, fill: 'normal' })))),
        react_1.default.createElement("g", null,
            react_1.default.createElement(recharts_1.Rectangle, { x: x, y: y - 7, width: width, height: 4, fill: fill }))));
}
exports.RangeAreaTick = RangeAreaTick;
//# sourceMappingURL=RangeAreaTick.js.map